module.exports = __webpack_public_path__ + "img/vela.905338c7.jpg";